export const NutmegResidence = {
  app: {
    name: "NutmegResidence",
    version: "1.0.0",
    description:
      "This is a platform that connects comfortable stays with guests around the world.",
    author: "NutmegResidence Team",
  },
  color: {
    primaryMain: "#FAF9F6",
    primaryMedium: "#F0EAD6",
    primaryDark: "#E9DCC9",
    secondaryMain: "#232323",
    secondaryMedium: "#4B5563",
    secondaryDark: "#9CA3AF",
    tertiaryMain: "#2563EB",
    tertiaryMedium: "#4d90a5",
    tertiaryDark: "#c4bdac",

    error: "#DC2626",
    success: "#10B981",
    warning: "#d1b03b",

    dark: "#000000",
    gray: "#6b6963",
    light: "#FFFFFF",
  },
  header: {
    title: "Your ideal job awaits, start the search",
    description: "We connects students with companies for internships",
  },
  strings: {
    postButton: "Post My Profile",
    facilitiesButton: "Facilities",
    finePrintButton: "The Fine Print",
    surroundingsButton: "Surrondings Nearby",
  },
  flags: {
    reservationEnabled: true,
  },
  gallery: [
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564429067.jpg?k=6012699cd75d0ce1af8a2fef18a00b72a8e68a5a357f9efec5727c17a0ffc713&o=&hp=1",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428979.jpg?k=b8122d817db7c7036303ede3e283429feba15f500eee3c5975d1a3b4a737f07c&o=&hp=1",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428964.jpg?k=3f90015bdb2119677bc7ba1826e3c934ba4b2a22f13cc65e7a47af2d9954788a&o=&hp=1",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428952.jpg?k=1e26b379cbceb637083fb44fc934c0f492377c00fbc5a5f9f636b290028e844a&o=&hp=1",
    },
  ],
  featureList: [
    { title: "1 Bedroom", isAvailable: true },
    { title: "1 Bathroom", isAvailable: true },
    { title: "Living Room", isAvailable: true },
    { title: "Dining Room", isAvailable: true },
    { title: "Air Conditioned Room", isAvailable: true },
    { title: "Hot Water Shower", isAvailable: true },
    { title: "Garden View", isAvailable: true },
    { title: "Private Entrance", isAvailable: true },
    { title: "Pool", isAvailable: false },
  ],
  propertyInfo: {
    description:
      "Nestled in the bustling heart of Galle town on Jail Road, Nutmeg Grove Villa offers a serene escape just minutes away from the historic Galle Fort, Galle railway station, and Galle bus stand. Despite its central location, you'll be amazed at how tranquil and green this minimalistic villa feels. Our comfortable accommodations feature air-conditioned rooms with modern amenities, beautiful garden views, and convenient access to shared living spaces. Hot water facilities and essential comforts ensure a pleasant stay for all our guests. We maintain a relaxed atmosphere while providing the perfect blend of convenience and tranquility at Nutmeg Grove Villa.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.6836085701552!2d80.21143540972972!3d6.038081793922277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae1730054a0da9b%3A0x6d12e87b2f017c9b!2sNutmeg%20Grove!5e0!3m2!1sen!2slk!4v1731661704367!5m2!1sen!2slk",
  },
  roomCategories: [
    {
      id: "villa",
      name: "Villa",
      shortDescription: "Entire villa with private garden",
      description:
        "The entire villa features a cosy air-conditioned bedroom, a private bathroom with hot water shower, and a comfortable living room. Enjoy access to a private dining area, beautiful garden views, and private entrance. Perfect for those seeking a complete home-away-from-home experience.",
      gallery: [
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564429067.jpg?k=6012699cd75d0ce1af8a2fef18a00b72a8e68a5a357f9efec5727c17a0ffc713&o=&hp=1",
        },
      ],
      featureList: [
        { title: "1 Bedroom", isAvailable: true },
        { title: "1 Bathroom", isAvailable: true },
        { title: "Living Room", isAvailable: true },
        { title: "Dining Room", isAvailable: true },
        { title: "Air Conditioned Room", isAvailable: true },
        { title: "Hot Water Shower", isAvailable: true },
        { title: "Garden View", isAvailable: true },
        { title: "Private Entrance", isAvailable: true },
        { title: "Pool", isAvailable: false },
      ],
      pricing: {
        currency: "LKR",
        basePrice: 15000,
        perNight: true,
      },
    },
  ],
  facilities: [
    {
      title: "Most Popular Facilities",
      description: [
        "Free WiFi",
        "Family Rooms",
        "Free Parking",
        "Non-smoking Rooms",
        "Private Entrance",
      ],
      isPinned: true,
    },
    {
      title: "Parking",
      description: ["Free private parking is available on site."],
    },
    {
      title: "Internet",
      description: ["WiFi is available in all areas and is free of charge."],
    },
    {
      title: "Kitchen",
      description: ["Dining table", "Electric kettle"],
    },
    {
      title: "Bathroom",
      description: [
        "Towels",
        "Private bathroom",
        "Toilet paper",
        "Linen",
        "Toilet",
        "Hairdryer",
        "Hot Water Shower",
      ],
    },
    {
      title: "Living Area",
      description: ["Dining area", "Sofa", "Seating Area"],
    },
    {
      title: "Media & Technology",
      description: ["Flat-screen TV", "Cable Channels"],
    },
    {
      title: "Room Amenities",
      description: [
        "Socket near the bed",
        "Drying rack for clothing",
        "Clothes rack",
        "Private entrance",
        "Fan",
        "Air conditioning",
      ],
    },
    {
      title: "Pets",
      description: ["Pets are not allowed."],
    },
    {
      title: "Accessibility",
      description: ["Entire unit located on ground floor"],
    },
    {
      title: "Outdoors",
      description: ["Garden", "Garden View"],
    },
    {
      title: "Food & Drink",
      description: ["Bottled water, Tea/Coffee"],
    },
    {
      title: "Miscellaneous",
      description: ["Family rooms", "Non-smoking rooms"],
    },
    {
      title: "Languages spoken",
      description: ["English", "Sinhala"],
    },
  ],
  reservationOptions: [
    {
      title: "Call Us",
      description: [
        "Reserve your stay directly by calling us at +1 234-567-890.",
      ],
      link: "tel:+345464564",
      linkLabel: "Call Now",
      icon: "CallIcon",
    },
    {
      title: "Booking.com",
      description: [
        "Book your stay through our official page on Booking.com.",
        "Get access to exclusive deals and offers.",
      ],
      link: "https://www.booking.com",
      linkLabel: "Reserve Now",
      icon: "LanguageIcon",
    },
    {
      title: "Instagram",
      description: [
        "Send us a direct message on Instagram to make your reservation.",
        "Follow us for updates and offers.",
      ],
      link: "https://www.instagram.com/yourbusinessname",
      linkLabel: "Contact Now",
      icon: "InstagramIcon",
    },
  ],
  finePrintData: [
    {
      title: "Reservation and Payment",
      description: [
        "Please ensure payment is completed as instructed to confirm your reservation.",
      ],
    },
    {
      title: "Check-in",
      description: [
        "From 14:00 to 18:00",
        "Guests are required to show a photo identification and credit card upon check-in.",
        "You'll need to let the property know in advance what time you'll arrive.",
      ],
    },
    {
      title: "Check-out",
      description: ["From 10:00 to 12:00"],
    },
    {
      title: "Check-in Requirements",
      description: [
        "Guests are required to show a photo identification (NIC / Passport) upon check-in.",
        "Guests under the age of 18 can only check in with a parent or official guardian.",
        "Please inform Villa Nutmeg Grove Galle in advance of your expected arrival time to ease the check-in process.",
      ],
    },

    {
      title: "Children and Beds",
      description: [
        "Children of any age are welcome.",
        "To see correct prices and occupancy information, please make sure you have added the correct number of children and their ages in your search.",
        "Cots and extra beds are not available at this property.",
        "There is no age requirement for check-in.",
      ],
    },
    {
      title: "Smoking",
      description: ["Smoking is not allowed."],
    },
    {
      title: "Parties",
      description: ["Parties/events are not allowed."],
    },
    {
      title: "Pets",
      description: ["Pets are not allowed."],
    },
    {
      title: "House Rules",
      description: [
        "For locals, stays of less than 2 nights are not allowed.",
        "A damage deposit may be requested in advance based on the length of stay or accommodation plan.",
        "This property will not accommodate hen, stag, or similar parties.",
        "Pets are not allowed.",
        "Smoking is not allowed inside the rooms.",
      ],
    },
    {
      title: "Cancellation Policy",
      description: [
        "Cancellations made 7 days or more prior to arrival date: Full refund of the deposit.",
        "Cancellations made between 2 and 6 days prior to arrival date: 50% of the deposit will be refunded.",
        "Cancellations made 24 hours or less prior to arrival date, or in case of no-show: No refund.",
      ],
    },
    {
      title: "Additional Information",
      description: [
        "All Special Requests are subject to availability and additional charges may apply.",
      ],
    },
  ],
  neighbourhoodData: [
    {
      title: "Key Attractions",
      items: [
        {
          name: "Galle Fort",
          description:
            "Step back in time as you explore this 17th-century fortification, rich with history and offering stunning views of the Indian Ocean.",
          icon: "FortIcon",
        },
        {
          name: "National Maritime Museum",
          description:
            "Showcases the region's naval history and maritime artifacts.",
          icon: "MuseumIcon",
        },
        {
          name: "Galle Dutch Hospital",
          description:
            "A beautifully restored colonial-era building housing shops, restaurants, and cafes.",
          icon: "RestaurantIcon",
        },
        {
          name: "Galle International Cricket Stadium",
          description:
            "Catch a match at this renowned stadium with a stunning backdrop of the Indian Ocean.",
          icon: "StadiumIcon",
        },
      ],
    },
    {
      title: "Local Delights",
      items: [
        {
          name: "Restaurants and Cafes",
          description:
            "Enjoy a variety of dining options, from local Sri Lankan cuisine to international flavors, including fresh seafood and aromatic curries.",
          icon: "RestaurantIcon",
        },
        {
          name: "Shopping",
          description:
            "Explore shops within the Fort offering handmade crafts, jewelry, stylish clothing, and souvenirs.",
          icon: "StorefrontIcon",
        },
        {
          name: "Cultural Sites",
          description:
            "Visit nearby museums and art galleries to immerse yourself in the rich cultural tapestry of Galle.",
          icon: "MuseumIcon",
        },
      ],
    },
    {
      title: "Scenic Spots",
      items: [
        {
          name: "Beaches",
          description:
            "Unwind on the golden sands of Unawatuna Beach or take a dip in the clear waters of Jungle Beach.",
          icon: "BeachAccessIcon",
        },
        {
          name: "Japanese Peace Pagoda",
          description:
            "Located on Rumassala Hill, this serene pagoda offers breathtaking views and a peaceful atmosphere.",
          icon: "MuseumIcon",
        },
        {
          name: "Rumassala Mountain",
          description:
            "Explore lush greenery and panoramic views from this hill, steeped in local legend.",
          icon: "LocationOnIcon",
        },
        {
          name: "Lighthouse",
          description:
            "The Galle Lighthouse, located within the Fort, is perfect for photography and offers panoramic coastal views.",
          icon: "LocationOnIcon",
        },
      ],
    },
    {
      title: "Convenience and Comfort",
      items: [
        {
          name: "Transport",
          description:
            "With the Galle Bus Stand and Railway Station close by, getting around is a breeze.",
          icon: "DirectionsTransitIcon",
        },
      ],
    },
  ],
  propertySurroundingsData: [
    {
      title: "What's nearby",
      items: [
        "Mahendra Amarasooriya Park - 1 km",
        "Galle Fort National Museum - 1.2 km",
        "Galle Fort Clock Tower - 1.2 km",
        "Little Smile Singithi Uyana - 1.3 km",
        "National Maritime Museum - 1.4 km",
        "Galle Fort - 1.4 km",
        "Galle Lighthouse - 1.9 km",
        "Galle Dadalla Sports Complex - 2.7 km",
        "Sport Ground - 8 km",
        "Parapduwa Nuns Island - 12 km",
      ],
    },
    {
      title: "Restaurants & cafes",
      items: [
        "New Lankan Restaurant - 400 m",
        "New Chinese Restaurant - 200 m",
        "Food Cabin - 650 m",
      ],
    },
    {
      title: "Natural beauty",
      items: [
        "Beekke Reservoir (Lake) - 2.2 km",
        "Kandawattagoda (Forest) - 12 km",
      ],
    },
    {
      title: "Beaches in the neighbourhood",
      items: [
        "Mahamodara Beach - 900 m",
        "Galle Fort Beach - 1.7 km",
        "Lighthouse Beach - 1.9 km",
        "Walawwatta Beach - 3.1 km",
        "Bonavista Beach - 3.5 km",
      ],
    },
    {
      title: "Public transport",
      items: [
        "Galle Railway Station - 700 m",
        "Richmond Hill - 2.9 km",
        "Hikkaduwa Bus Stand - 18 km",
      ],
    },
    {
      title: "Closest airports",
      items: ["Koggala Airport - 14 km"],
    },
  ],
};
